import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Translation from '@swf/components/Translation/Translation';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

import { TXTACL_Play_Money, TXTACL_Real_Money } from './DesktopPlayMoneyToggle.messages.json';
import styles from './DesktopPlayMoneyToggle.scss';

const DesktopPlayMoneyToggle: React.FC = () => {
  const playMoney = useSelector(select.currency.isPlayMoney);
  const {
    currency: { setPlayMoney }
  } = useDispatch<Dispatch>();

  const togglePlayMoney = () => setPlayMoney({ selected: !playMoney });

  return (
    <div className={styles.wrapper}>
      <input
        id="desktopplaymoneytoggle-real-money"
        name="desktopplaymoneytoggle"
        type="radio"
        checked={!playMoney}
        className={styles.toggle}
        onChange={togglePlayMoney}
      />
      <label className={styles.label} htmlFor="desktopplaymoneytoggle-real-money">
        <Translation {...TXTACL_Real_Money} />
      </label>
      <input
        id="desktopplaymoneytoggle-play-money"
        name="desktopplaymoneytoggle"
        type="radio"
        className={styles.toggle}
        checked={playMoney}
        onChange={togglePlayMoney}
      />
      <label className={styles.label} htmlFor="desktopplaymoneytoggle-play-money">
        <Translation {...TXTACL_Play_Money} />
      </label>
    </div>
  );
};

export default DesktopPlayMoneyToggle;
